export type RuntimeConfig = {
  /** Empty = same origin (CloudFront). */
  apiBase: string;
};

declare global {
  interface Window {
    __FILE_SHARE_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const defaults: RuntimeConfig = {
  apiBase: import.meta.env.VITE_API_BASE || "",
};

export function getConfig(): RuntimeConfig {
  return { ...defaults, ...(window.__FILE_SHARE_CONFIG__ || {}) };
}
